import { helpers } from '@vuelidate/validators'
import type { ValidatorFn } from '@vuelidate/core'

const dollarAmount: ValidatorFn = (value): boolean => {
  return !helpers.req(value) ||
  /^[-]?\d*(\.\d{1,2})?$/.test(value)
}

export default dollarAmount
